// CYBERCAFÉ CUSTOM: Auto-apply "In stock" filter when any other filter is active
(function () {
  const AVAILABILITY_PARAM = 'filter.v.availability';
  const IN_STOCK_VALUE = '1'; // Shopify's value for "In stock"

  // Wait for the custom element to be defined
  customElements.whenDefined('facets-form-component').then(() => {
    const FacetsFormComponent = customElements.get('facets-form-component');
    const originalCreateURLParameters = FacetsFormComponent.prototype.createURLParameters;

    FacetsFormComponent.prototype.createURLParameters = function (formData) {
      const params = originalCreateURLParameters.call(this, formData);

      // Check if any non-availability filter is active
      let hasActiveFilter = false;
      for (const [key] of params.entries()) {
        if (key.startsWith('filter.') && key !== AVAILABILITY_PARAM) {
          hasActiveFilter = true;
          break;
        }
      }

      // Auto-apply in-stock if other filters are active
      if (hasActiveFilter && !params.has(AVAILABILITY_PARAM)) {
        params.append(AVAILABILITY_PARAM, IN_STOCK_VALUE);
      }

      return params;
    };
  });
})();